<div class="text-center text-muted mt-4 pt-4 pb-4">
  <h1 class="display-1 mt-4 pt-4 pb-4">Checking Sign in...</h1>
</div>
